import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ExpansionPanelComponent } from '@shared/components/expansion-panel';

@Component({
  selector: 'app-version',
  providers: [
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'dd/MM/yyyy', timezone: '+0000' },
    },
  ],
  imports: [ExpansionPanelComponent, DatePipe],
  templateUrl: './version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './version.component.scss',
})
export class VersionComponent {
  x: test[] = [
    {
      version: '10.20.0',
      date: new Date('01/10/2024 12:00:00'),
      content: ['truc', 'truc2', 'truc3'],
    },
    {
      version: 'v1.1',
      date: new Date('12/08/2024 12:00:00'),
      content: ['truc', 'truc2', 'truc3'],
    },
    {
      version: 'v1.0',
      date: new Date('05/07/2024 12:00:00'),
      content: ['truc', 'truc2', 'truc3'],
    },
  ];
}

export interface test {
  version: string;
  date: Date;
  content: string[];
}
